import { useQuery } from "react-query";
import API from "../shared-utils/api";
const getLocationDetails = async (locationId) => {
    const { data } = await API.get(`/api/v1/rbzo/locations/${locationId}`);
    return data;
};
export const useLocationDetails = (locationId) => useQuery(["locationDetails", locationId], () => getLocationDetails(locationId), {
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 7 * 60 * 1000,
    retry: 2,
});
